import { storybookReady, mediaNotSmall } from '../../../core/js/utils'

(async function() {
  await storybookReady()

/**
 * Pick the components DOM references
 */
let component = document.querySelectorAll('.glide')

if (!mediaNotSmall()) {
  component = Array.from(component).filter(item => !item.closest('.noslider--small'))
}

component.forEach(item => {
  slider(item)
})

})()

/**
 * Init the JS component on each reference
 */

const gap = item => {
  const value = parseInt(item.getAttribute('data-glide-gap'))
  return value >= 0 ? value : 24
}

/**
 * Handle the fullscreen mode and the expand/collapse icon
 * @param {HTMLElement} item
 * @param {Function} glide
 * @param {HTMLElement} trigger
 */
const handleFullscreen = (item, glide, trigger) => {
  const body = document.body
  const iconElement = trigger.querySelector('use')
  const currentIcon = iconElement.getAttribute('xlink:href')

  if (body.hasAttribute('data-fullscreen')) {
    glide.update({
      peek: {
        before: 50,
        after: 50
      }
    })
    document.exitFullscreen()
    body.removeAttribute('data-fullscreen')
    iconElement.setAttribute('xlink:href', currentIcon.replace('collapse', 'expand'))
  } else {
    item.requestFullscreen()
    body.setAttribute('data-fullscreen', '')
    glide.update({
      peek: {
        before: 10,
        after: 10
      }
    })
    iconElement.setAttribute('xlink:href', currentIcon.replace('expand', 'collapse'))
  }
}

export default function slider(item) {

  const fullScreenTrigger = item.querySelector('[data-glide-fullscreen]')

  const nav = item.querySelector('[data-glide-el="controls[nav]"]')
  if (nav) {
    const slidesCount = item.querySelectorAll('.glide__slide')
    const fragment = document.createDocumentFragment()
    slidesCount.forEach((item, i) => {
      const button = document.createElement('button')
      button.classList.add('glide__bullet')
      button.setAttribute('data-glide-dir', `=${i}`)
      button.setAttribute('tabindex', '0')
      fragment.appendChild(button)
    })

    nav.appendChild(fragment)
  }

  setTimeout(() => {

  // https://glidejs.com/docs/options/
  const glide = new Glide(item, {
    type: item.getAttribute('data-glide-type') || 'slider',
    gap: gap(item),
    rewind: false,
    perView: item.getAttribute('data-glide-perview') || 5,
    focusAt: item.getAttribute('data-glide-focusat') || 1,
    bound: false,
    peek: {
      before: item.getAttribute('data-glide-peek-before') || 50,
      after: item.getAttribute('data-glide-peek-after') || 50
    },
    breakpoints: {
      1280: {
        perView: item.getAttribute('data-glide-perview-1280') || item.getAttribute('data-glide-perview') || 4,
        focusAt: item.getAttribute('data-glide-focusat') || 1,
        peek: {
          before: item.getAttribute('data-glide-peek-before-1280') || 100,
          after: item.getAttribute('data-glide-peek-after-1280') || 100
        }
      },
      960: {
        perView: item.getAttribute('data-glide-perview-960') || item.getAttribute('data-glide-perview') || 3,
        focusAt: item.getAttribute('data-glide-focusat') || 0,
        peek: {
          before: item.getAttribute('data-glide-peek-before-960') || 100,
          after: item.getAttribute('data-glide-peek-after-960') || 100
        }
      },
      768: {
        perView: item.getAttribute('data-glide-perview-768') || item.getAttribute('data-glide-perview') || 2,
        focusAt: item.getAttribute('data-glide-focusat') || 0,
        peek: {
          before: item.getAttribute('data-glide-peek-before-768') || 100,
          after: item.getAttribute('data-glide-peek-after-768') || 100
        }
      },
      480: {
        perView: item.getAttribute('data-glide-perview-480') || item.getAttribute('data-glide-perview') || 1,
        focusAt: item.getAttribute('data-glide-focusat') || 0,
        peek: {
          before: item.getAttribute('data-glide-peek-before-480') || 20,
          after: item.getAttribute('data-glide-peek-after-480') || 20
        }
      }
    },
    startAt: item.getAttribute('data-glide-startat') || 0,
    animationDuration: 200 // PITTIECO-483
  })

  glide.on('mount.before', function() {
    let index = glide.index;
    if (index === 0)
    {
      item.querySelector('.glide__arrow--left').setAttribute('data-hidden', '')
    }
  })

  glide.on('move', function (e,f) {
    let index = glide.index;
    let numberOfSlides = item.querySelector('.glide__slides').children.length;
    let isLastSlide = (index + 1) === numberOfSlides
    if (index !== 0)
    {
      item.querySelector('.glide__arrow--left').removeAttribute('data-hidden')
    }
    if (index === 0)
    {
      item.querySelector('.glide__arrow--left').setAttribute('data-hidden', '')
    }
    if (isLastSlide)
    {
      item.querySelector('.glide__arrow--right').setAttribute('data-hidden', '')
    }
    if (!isLastSlide)
    {
      item.querySelector('.glide__arrow--right').removeAttribute('data-hidden')
    }

  })

  if (item.closest('.ePittiComponent')) {
    glide.on('build.after', function() {
      item.querySelectorAll('.glide__slide').forEach(slide => {
        slide.style.height = slide.style.width
      })
    })
  }

  glide.mount()

  }, 100)

  if (fullScreenTrigger) {
    fullScreenTrigger.addEventListener('click', () => {
      handleFullscreen(item, glide, fullScreenTrigger)
    })
  }

}
